import React from "react";
import QuizOptions from "./QuizOptions";

export default function QuizQuestion({ quiz, handleOptionSelected }) {
  const { question, options, id: quizId } = quiz;

  return (
    <div className="quiz">
      <h4 className="question">{question}</h4>
      <QuizOptions
        question={question}
        quizId={quizId}
        handleOptionSelected={handleOptionSelected}
        options={options}
      />
    </div>
  );
}
